<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="!loadDone">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardPopupImg
        :cardContent="content"
        :cardType="cardType"
        :isModalVisible="isShow"
        @popupData2="popupData2"
        :CheckWidth="CheckWidth"
        :score="score"
        :maxscore="maxscore"
        @updateUser="updateUser"
        :showWarning="showWarning"
        :previousScore="previousScore"
      />
    </template>
  </div>
</template>

<script>
import LoadingMDL from '../../../components/loading/LoadingMDL';
import CardPopupImg from './components/CardPopupImg.vue';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';
import '../../../assets/scss/_chineseModalCustom.scss';
import TEMPLATE from '../../../TEMPLATE.vue';

export default {
  components: {CardPopupImg, TEMPLATE, LoadingMDL},
  name: 'LKS01',
  data() {
    return {
      code: '',
      lang: '',
      content: {},
      type: '',
      isShow: true,
      cardType: 'score',
      openModalImage: true,
      score: 0,
      CheckWidth: window.innerWidth.toString(),
      maxscore: 0,
      LessonID: 0,
      mode: {},
      assignmentTestScore: {},
      prepostTestScore: {},
      courseSection: '',
      startTime: '',
      courseCode: '',
      condition: [],
      courseSection: '',
      loadDone: false,
      v3Data: {},
      nextPath: null,
      showWarning: false,
      previousScore: 0,
    };
  },

  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates',
      saveScoreAndProgress: 'v3/saveScoreAndProgress',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
      getScoreResultv4: 'v4-data/getScoreResultv4',
      getSaveScoreResultv4: 'v4-data/getSaveScoreResultv4',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template;
      this.navigate = template.navigate;

      if (!template.enable) {
        const pathFormat = template.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      }

      //stamp ?
      this.$store.commit('v3/stampMainCodeItem', val.codeItem);

      this.$store.dispatch('v4/stampCurrentScore', this.v3Data);
      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);
    },
    saveContentStatusv4: function (val) {
      // console.log(val, 'LKS01 Watcher Call');
      if (this.nextPath) {
        this.loadDone = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
    getScoreResultv4: function (val) {
      // console.log(val, 'score result');
      let realScore;
      let realMaxScore;
      const pageType = this.$store.state.v4.v4MainType;

      //f score for show
      if (pageType === 'test') {
        realMaxScore = 20;
        if (val.score > 20) {
          realScore = 20;
        } else {
          realScore = val.score;
        }
      } else if (pageType === 'pretest' || pageType === 'posttest') {
        realMaxScore = 50;
        if (val.score > 50) {
          realScore = 50;
        } else {
          realScore = val.score;
        }
      } else {
        realMaxScore = val.maxScore;
        realScore = val.score;
      }

      //assign score
      this.score = String(realScore).padStart(2, '0');
      this.maxscore = String(realMaxScore).padStart(2, '0');
    },
    getSaveScoreResultv4(val) {
      // console.log(val, 'save Completed');
      if (!val) return;
      console.log(val, 'response score');

      //check finish status
      if (val.response.finish) {
        this.showWarning = true;
        this.previousScore = val.response.score;
      }

      //loading done after get score
      this.loadDone = true;
    },
  },

  mounted() {
    this.lang = this.$store.state.language.language;

    this.onLoad();
    //dispatch dataStack to calculate Score
    this.$store.dispatch(
      'v4-data/getScoreResultv4',
      this.$store.state.v4.v4DataStack
    );
  },

  created() {},

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.loading = true;

      this.$store.commit('v3/clearScoreAndProgress');
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.startTime = this.$helpers.getDateFormat();
      this.courseSection =
        this.$store.getters['necessary/getUserCourseSection'];
      const contentId = `LKS01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
      // return "container-chinese-card-mobile"
    },
    popupData2: function (val) {},
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    updateUser(path) {
      this.commitPayloadData(path);
    },
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
        // score: 0,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });
          this.nextPath = path;
        } else {
          //onNext
          const str = path.split('-');
          const nextPath = `/v4/${str[0]}/${str[1]}`;
          this.$router.push(nextPath);
        }
        //if not just clear stack
        // this.$store.commit('v4/clearPayloadStack');
      }
    },
  },
};
</script>
<style></style>
